import { render, staticRenderFns } from "./PurchaseOrders.vue?vue&type=template&id=581e867d&scoped=true&"
import script from "./PurchaseOrders.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOrders.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseOrders.vue?vue&type=style&index=0&id=581e867d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581e867d",
  null
  
)

export default component.exports